import classNames from 'classnames'
import React from 'react'

import { CardProps, CardSubComponents } from './Card.types.ts'

const Card: React.FC<CardProps> & CardSubComponents = ({
  children,
  className
}) => {
  return (
    <div
      className={classNames(
        'rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark',
        className
      )}
    >
      {children}
    </div>
  )
}

Card.Title = ({ children, className, isChildPlainText = true }: CardProps) => {
  return (
    <div
      className={classNames(
        'border-b border-stroke py-4 px-7 dark:border-strokedark',
        className
      )}
    >
      {isChildPlainText && (
        <h3 className="font-medium text-xl text-black dark:text-white">
          {children}
        </h3>
      )}

      {!isChildPlainText && (
        <div className="font-medium text-xl text-black dark:text-white">
          {children}
        </div>
      )}
    </div>
  )
}

Card.Body = ({ children, className }: CardProps) => {
  return <div className={classNames('p-2 md:p-7', className)}>{children}</div>
}

export default Card
